export function cleanDeveloperName(name) {
  return (name || '').replace(/^["',;\s]+|["',;\s]+$/g, '').trim();
}

/** Effective star rating 0-3. Legacy top devs (flagged, no topStars) count as 1 — no DB migration. */
export function topStarsOf(x) {
  return (x && x.topStars) || (x && x.isTopDeveloper ? 1 : 0);
}

/** Merge lead bank + companies by name+city; prefer starred entry when deduping. */
export function buildTopDeveloperEntries(leadBank = [], companies = []) {
  const all = [
    ...leadBank
      .filter(x => cleanDeveloperName(x.name).length > 1)
      .map(x => ({ ...x, name: cleanDeveloperName(x.name), _src: 'lead' })),
    ...companies
      .filter(co => cleanDeveloperName(co.name).length > 1)
      .map(co => ({
        _id: String(co._id),
        name: cleanDeveloperName(co.name),
        city: co.city,
        isTopDeveloper: co.isTopDeveloper,
        topStars: co.topStars,
        _src: 'company',
      })),
  ];

  return Object.values(
    all.reduce((map, entry) => {
      const key = `${(entry.name || '').toLowerCase().trim()}|${entry.city}`;
      if (!map[key] || topStarsOf(entry) > topStarsOf(map[key])) map[key] = entry;
      return map;
    }, {})
  );
}

export function countTopDevelopers(leadBank = [], companies = [], { city } = {}) {
  return buildTopDeveloperEntries(leadBank, companies).filter(entry => {
    if (!topStarsOf(entry)) return false;
    if (city && entry.city !== city) return false;
    return true;
  }).length;
}
